import React from "react";
import { motion } from "framer-motion";
import {
  Store,
  Truck,
  Package,
  Users,
  Briefcase,
  Factory,
  Leaf,
  Pill,
  FlaskConical,
  Star,
  Beaker,
  Globe,
  ShieldCheck,
} from "lucide-react";

export default function OurMilestones() {
  const milestones = [
    { year: "2009", text: "Launch of Retail Business – Entered the pharmaceutical distribution market.", icon: Store },
    { year: "2010", text: "Expansion to Sub-Wholesaler Operations – Built strong relationships with local pharmacies.", icon: Truck },
    { year: "2011", text: "Recognized as Sub-Stockist – Achieved significant sales growth and extended presence.", icon: Package },
    { year: "2012", text: "Recognized as Super Stockist – Secured exclusive distribution rights.", icon: Users },
    { year: "2013", text: "Appointed as Distributor – Managed large-scale supply chains.", icon: Briefcase },
    { year: "2014", text: "Established as Consignment Agent – Strengthened logistics and inventory management.", icon: Factory },
    { year: "2015", text: "Initiated C&F Business – Enhanced warehousing and faster delivery timelines.", icon: Briefcase },
    { year: "2016", text: "Started Manufacturing Ayurveda Products – Entered the health & wellness segment.", icon: Leaf },
    { year: "2017", text: "Entered Nutraceutical Manufacturing – Diversified into supplements and wellness products.", icon: Pill },
    { year: "2018", text: "Third-Party Pharmaceutical Manufacturing – Expanded services with industry partnerships.", icon: Star },
    { year: "2019", text: "In-house Pharmaceutical Manufacturing – Strengthened quality and compliance.", icon: Factory },
    { year: "2020", text: "Expanded into API Trading – Built supplier relationships for efficiency.", icon: FlaskConical },
    { year: "2021", text: "Launched API/Intermediate Manufacturing – Achieved backward integration.", icon: FlaskConical },
    { year: "2022", text: "Entered Specialty Chemicals & Cosmetic UV Filters – Diversified into high-value chemicals.", icon: Beaker },
    { year: "2023", text: "Developed In-house R&D Capabilities – Invested in innovation and IP development.", icon: FlaskConical },
    { year: "2024", text: "Domestic & International Market Expansion – Forged global partnerships and exports.", icon: Globe },
    { year: "2025", text: "Achieved Full Regulatory-Market Presence – Established an end-to-end pharma ecosystem.", icon: ShieldCheck },
  ];

  return (
    <div>
      {/* ✅ Hero Banner */}
      <div
        className="relative h-[300px] md:h-[400px] w-full bg-cover bg-center flex items-center justify-center"
        style={{
          backgroundImage: "url('/images/milestone.webp')", // Add image in public/images/
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <h1 className="relative text-3xl md:text-5xl font-bold text-white text-center">
          Growth Roadmap (2009 - 2025)
        </h1>
      </div>

      {/* ✅ Timeline */}
      <motion.section
        id="our-milestones"
        className="relative max-w-6xl mx-auto px-4 md:px-6 py-16"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        <motion.h2
          className="text-3xl md:text-4xl font-extrabold text-center mb-12 text-[#0d47a1]"
          initial={{ opacity: 0, y: -40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Our Milestones
        </motion.h2>

        <div className="relative">
          {/* Timeline line (only desktop) */}
          <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 w-1 bg-[#f57c00] h-full"></div>

          {milestones.map((item, index) => {
            const Icon = item.icon;
            const isLeft = index % 2 === 0;

            return (
              <motion.div
                key={index}
                className={`mb-12 flex w-full ${
                  isLeft ? "md:justify-start md:pr-8" : "md:justify-end md:pl-8"
                }`}
                initial={{ opacity: 0, x: isLeft ? -100 : 100 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.7 }}
                viewport={{ once: true }}
              >
                {/* Card */}
                <div
                  className={`relative w-full md:w-[45%] bg-white shadow-xl rounded-2xl p-4 md:p-6 border border-gray-200`}
                >
                  {/* Icon circle (inside for mobile, outside for desktop) */}
                  <span
                    className={`absolute top-4 left-4 w-10 h-10 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-[#0d47a1] text-white shadow-lg ${
                      isLeft ? "md:-right-20 md:left-auto" : "md:-left-20"
                    }`}
                  >
                    <Icon className="w-5 h-5 md:w-6 md:h-6" />
                  </span>

                  <h3 className="text-lg md:text-xl font-bold text-[#0d47a1] mt-12 md:mt-0">
                    {item.year}
                  </h3>
                  <p className="text-gray-700 mt-2 text-sm md:text-base">
                    {item.text}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </motion.section>
    </div>
  );
}
